module.exports = __webpack_public_path__ + "static/media/Fund management.c62e4126.png";